import { render, staticRenderFns } from "./group-question.vue?vue&type=template&id=675a83c0"
import script from "./group-question.vue?vue&type=script&lang=js"
export * from "./group-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports